import { call, put } from 'redux-saga/effects';
import {
  deleteEntityGroupFailure,
  deleteEntityGroupSuccess,
  fetchOrganisationsLightRequest,
} from '../actions';
import { deleteEntityGroup } from '../api';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { DeleteEntityGroupRequestAction } from '../types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* deleteEntityGroupSaga(action: DeleteEntityGroupRequestAction) {
  try {
    let err: ApiError | null;
    const { groupId } = action.payload;
    const response: ApiResponse = yield call(deleteEntityGroup, groupId);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(deleteEntityGroupSuccess());
    yield put(fetchOrganisationsLightRequest());
    yield put(
      turnMessageOn({
        title: i18n.t('common.success'),
        description: i18n.t('notifications.group-deleted-successfully'),
        type: MessageStates.SUCCESS,
      } as MessageData)
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(deleteEntityGroupFailure());
  }
}
